import { render, staticRenderFns } from "./Bando31Fase2.vue?vue&type=template&id=a4974f5c&scoped=true"
import script from "./Bando31Fase2.vue?vue&type=script&lang=js"
export * from "./Bando31Fase2.vue?vue&type=script&lang=js"
import style0 from "./Bando31Fase2.vue?vue&type=style&index=0&id=a4974f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4974f5c",
  null
  
)

export default component.exports